import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme } from '../../Theming';

const Button = styled.button`
  padding: 1rem;
  font-weight: 600;
  letter-spacing: 0.5;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out 0s;
  &:hover {
    opacity: 0.8;
  }
`;

const buttonColorTypes = {
  1: theme.colors.midBlue,
  2: theme.colors.darkBlue,
  3: theme.colors.black,
};
const buttonTypes = {
  primary: {
    border: 'none',
  },
  secondary: { border: '1.5px solid' },
};

type CustomButtonProps = React.CSSProperties & {
  type?: keyof typeof buttonTypes;
  colorType?: keyof typeof buttonColorTypes;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const CustomButton: React.FC<PropsWithChildren<CustomButtonProps>> = ({
  children,
  type = 'primary',
  colorType = 1,
  onClick,
  ...rest
}) => {
  const color = buttonColorTypes[colorType ?? 1];
  return (
    <Button
      onClick={onClick}
      style={{
        backgroundColor: type === 'primary' ? color : 'transparent',
        borderRadius: '6px',
        borderColor: type === 'secondary' ? color : 'transparent',
        color: type === 'secondary' ? color : 'white',
        ...buttonTypes[type ?? 'primary'],
        ...rest,
      }}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
